<script lang="ts">
  import i18n from '../../i18n'
  import ContextMenuContent from '../context-menu/ContextMenuContent.svelte'
  import ContextMenuSeparator from '../context-menu/ContextMenuSeparator.svelte'
  import ContextMenuItem from '../context-menu/ContextMenuItem.svelte'
  import useObjectQueries from '../../routes/project/hooks/useObjectQueries'

  type Props = {
    groupId: string
    // assignedPrinterId?: string
    onRename: () => void
  }

  let { groupId, onRename }: Props = $props()
  const { focusCamera, removeMutation } = useObjectQueries()
</script>

<ContextMenuContent>
  <ContextMenuItem onClick={onRename}>
    {$i18n.t('project.leftBar.groups.contextMenu.rename')}
  </ContextMenuItem>
  <ContextMenuItem onClick={() => focusCamera(groupId)}>
    {$i18n.t('project.leftBar.groups.contextMenu.focus')}
  </ContextMenuItem>

  <ContextMenuSeparator />
  <ContextMenuItem
    onClick={() => removeMutation.mutate(groupId)}
    variant="destructive"
  >
    {$i18n.t('project.leftBar.groups.contextMenu.delete')}
  </ContextMenuItem>
</ContextMenuContent>
